export default "__VITE_ASSET__nNzDyfVF__"